module.exports = __webpack_public_path__ + "static/media/butcher-0.ec819f01.png";